var exports = {
  "X": "xcc377c0b--841b81--contacts-card",
};

module.exports = exports;
